/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusdraft2Inputs */

const en_crosspostingstatusdraft2 = /** @type {(inputs: Crosspostingstatusdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const de_crosspostingstatusdraft2 = /** @type {(inputs: Crosspostingstatusdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Crosspostingstatusdraft2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusdraft2 = /** @type {((inputs?: Crosspostingstatusdraft2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusdraft2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusdraft2(inputs)
	return de_crosspostingstatusdraft2(inputs)
});
export { crosspostingstatusdraft2 as "crosspostingStatusDraft" }